exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conditions-container[data-v-0ad176d8] {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.conditions-hint[data-v-0ad176d8] {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6c737f;\n}\n.conditions-warning[data-v-0ad176d8] {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #fffaeb;\n  color: #b54708;\n  font-size: 13px;\n}", ""]);

// exports
